import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import { SimpleDynamicFormComponent } from 'src/app/shared/simple-form/simple-dynamic-form/simple-dynamic-form.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sub-status-update-dialog',
  templateUrl: './sub-status-update-dialog.component.html',
  styleUrls: ['./sub-status-update-dialog.component.scss']
})
export class SubStatusUpdateDialogComponent implements OnInit {

  notes: string = '';
  documents: string[] = []; // store filenames of attached documents
  
  public serverPath = environment.commonImageApi + "stageHistory/";

  regConfig: any[] = [];
  patchValues: any = {};
  formInit: boolean = false;
  finalValueForm: any = {};

  @ViewChild(SimpleDynamicFormComponent) dynamicFormComp: SimpleDynamicFormComponent;

  constructor(
    public dialogRef: MatDialogRef<SubStatusUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dynamicFormLabelService: DynamicFormLabelService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.data?.dynamicFormGroupId && Number(this.data.dynamicFormGroupId) > 0) {
      this.loadDynamicForm(Number(this.data.dynamicFormGroupId));
    }
  }

  normalizeKey(key: string): string {
    return (key || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/_/g, '');
  }

  loadDynamicForm(formGroupId: number): void {
    this.formInit = false;
    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe({
      next: (data: any) => {
        const fields = Array.isArray(data) ? data : (data?.data || []);
        if (fields && fields.length > 0) {
          this.regConfig = fields;
          const entity = this.data.entityObject || {};
          const custom10 = entity.customField10 || {};
          const rawValues = { ...custom10, ...entity };

          const mappedPatchValues: any = { ...rawValues };
          this.regConfig.forEach((field: any) => {
            if (field.name) {
              const normalizedFieldName = this.normalizeKey(field.name);
              for (const key of Object.keys(rawValues)) {
                if (this.normalizeKey(key) === normalizedFieldName) {
                  mappedPatchValues[field.name] = rawValues[key];
                  break;
                }
              }
            }
          });

          this.patchValues = mappedPatchValues;
          this.formInit = true;
          this.cdr.detectChanges();
        }
      },
      error: (err) => {
        console.error("Error loading dynamic form fields", err);
      }
    });
  }

  onFormSubmitted(event: any): void {
    this.finalValueForm = event || {};
  }

  saveNew(event: any): void {
    this.finalValueForm = event || {};
  }

  onDocumentsChange(docs: string[]): void {
    this.documents = docs || [];
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  get isValid(): boolean {
    if (this.data.requireNotes && (!this.notes || this.notes.trim() === '')) {
      return false;
    }
    if ((this.data.requireImages || this.data.requireDocuments) && this.documents.length === 0) {
      return false;
    }
    return true;
  }

  text: string = 'Update & Save';

  async onSave(): Promise<void> {
    if (!this.isValid) return;

    if (this.formInit && this.dynamicFormComp && this.dynamicFormComp.form) {
      if (!this.dynamicFormComp.form.valid) {
        this.dynamicFormComp.validateAllFormFields(this.dynamicFormComp.form);
        return;
      }
      this.finalValueForm = this.dynamicFormComp.form.value;
    }

    this.text = 'Processing...';
    
    const payload = {
      notes: this.notes,
      images: this.documents.length > 0 ? JSON.stringify(this.documents) : null,
      dynamicFormValues: this.finalValueForm,
      dynamicFormGroupId: this.data.dynamicFormGroupId
    };

    if (this.data.saveCallback) {
      try {
        await this.data.saveCallback(payload);
        this.dialogRef.close(true);
      } catch (err) {
        this.text = 'Update & Save';
      }
    } else {
      this.dialogRef.close(payload);
    }
  }

}

